const baseStats = {
	1:{
		HP: 10,
		BAB: 1,
		AC: 0,
		GoodSave: 2,
		PoorSave: 0,
		AbilityIncrease: 0,
		Feat: 1,
		Mod: 1,
		RP: false
	},
	2:{
		HP: 20,
		BAB: 2,
		AC: 1,
		GoodSave: 3,
		PoorSave: 0,
		AbilityIncrease: 0,
		Feat: 1,
		Mod: 1,
		RP: false
	},
	3:{
		HP: 30,
		BAB: 3,
		AC: 2,
		GoodSave: 3,
		PoorSave: 1,
		AbilityIncrease: 0,
		Feat: 2,
		Mod: 2,
		RP: false
	},
	4:{
		HP: 40,
		BAB: 3,
		AC: 3,
		GoodSave: 3,
		PoorSave: 1,
		AbilityIncrease: 1,
		Feat: 2,
		Mod: 2,
		RP: false
	},
	5:{
		HP: 50,
		BAB: 4,
		AC: 4,
		GoodSave: 4,
		PoorSave: 1,
		AbilityIncrease: 1,
		Feat: 2,
		Mod: 3,
		RP: false
	},
	6:{	
		HP: 60,
		BAB: 5,
		AC: 5,
		GoodSave: 4,
		PoorSave: 1,
		AbilityIncrease: 1,
		Feat: 3,
		Mod: 3,
		RP: false
	},
	7:{
		HP: 70,
		BAB: 6,
		AC: 6,
		GoodSave: 5,
		PoorSave: 2,
		AbilityIncrease: 2,
		Feat: 3,
		Mod: 4,
		RP: false
	},
	8:{
		HP: 80,
		BAB: 6,
		AC: 7,
		GoodSave: 5,
		PoorSave: 2,
		AbilityIncrease: 2,
		Feat: 3,
		Mod: 4,
		RP: false
	},
	9:{
		HP: 90,
		BAB: 7,
		AC: 8,
		GoodSave: 5,
		PoorSave: 2,
		AbilityIncrease: 2,
		Feat: 4,
		Mod: 5,
		RP: false
	},
	10:{
		HP: 100,
		BAB: 8,
		AC: 9,
		GoodSave: 6,
		PoorSave: 2,
		AbilityIncrease: 3,
		Feat: 4,
		Mod: 5,
		RP: 5
	},
	11:{
		HP: 110,
		BAB: 9,
		AC: 9,
		GoodSave: 6,
		PoorSave: 3,
		AbilityIncrease: 3,
		Feat: 5,
		Mod: 6,
		RP: 5
	},
	12:{
		HP: 120,
		BAB: 9,
		AC: 10,
		GoodSave: 6,
		PoorSave: 3,
		AbilityIncrease: 3,
		Feat: 5,
		Mod: 6,
		RP: 6
	},
	13:{
		HP: 130,
		BAB: 10,
		AC: 11,
		GoodSave: 7,
		PoorSave: 3,
		AbilityIncrease: 4,
		Feat: 5,
		Mod: 7,
		RP: 6
	},
	14:{
		HP: 140,
		BAB: 11,
		AC: 12,
		GoodSave: 7,
		PoorSave: 3,
		AbilityIncrease: 4,
		Feat: 6,
		Mod: 7,
		RP: 7
	},
	15:{
		HP: 150,
		BAB: 12,
		AC: 13,
		GoodSave: 8,
		PoorSave: 4,
		AbilityIncrease: 4,
		Feat: 6,
		Mod: 8,
		RP: 7
	},
	16:{
		HP: 160,
		BAB: 12,
		AC: 14,
		GoodSave: 7,
		PoorSave: 3,
		AbilityIncrease: 5,
		Feat: 6,
		Mod: 8,
		RP: 8
	},
	17:{
		HP: 170,
		BAB: 13,
		AC: 15,
		GoodSave: 8,
		PoorSave: 4,
		AbilityIncrease: 5,
		Feat: 7,
		Mod: 9,
		RP: 8
	},
	18:{
		HP: 190,
		BAB: 14,
		AC: 16,
		GoodSave: 9,
		PoorSave: 4,
		AbilityIncrease: 5,
		Feat: 7,
		Mod: 9,
		RP: 9
	},
	19:{
		HP: 210,
		BAB: 15,
		AC: 17,
		GoodSave: 9,
		PoorSave: 5,
		AbilityIncrease: 6,
		Feat: 8,
		Mod: 10,
		RP: 9
	},
	20:{
		HP: 230,
		BAB: 15,
		AC: 18,
		GoodSave: 9,
		PoorSave: 5,
		AbilityIncrease: 6,
		Feat: 8,
		Mod: 10,
		RP: 10
	},
}

import _merge from 'lodash.merge'

const state = {
	stats: baseStats,
}

const getters = {
	drone: (state, getters, rootState, rootGetters) => {
		return rootState.Character.Levels[rootGetters.currentLevel].Drone || null
	},
	name: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Name || null
	},
	dlevel: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Level || null
	},
	type: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Type || null
	},
	size: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Size || null
	},
	speed: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Speed || null
	},
	eac: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.EAC || null
	},
	kac: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.KAC || null
	},
	save: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.GoodSave || null
	},
	skills: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Skills || null
	},
	initial: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.InitialMods || null
	},
	scores: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.AbilityScores || null
	},
	increases: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.AbilityIncreases || null
	},
	mods: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Mods || null
	},
	feats: (state, getters, rootState) => (level) => {
		return rootState.Character.Levels[level].Drone.Feats || null
	},
	hasDrone: (state, getters) => {
		return getters.drone != null
	},
	hasDroneAtLevel: (state, getters, rootState) => (concernedLevel) => {
		var levels = rootState.Character.Levels
		for (const level in levels) {
			if(level <= concernedLevel && levels[level].Drone != undefined){
				return true
			}
		}
		return false
	},
	stats: (state, getters) => {
		if( getters.drone != null ){
			return state.stats[getters.drone.Level]
		} else {
			return null
		}
	},
	abilityScores: () => {
		return {}
	},
	abilityMods: (state, getters) => {
		if(getters.drone != null){
			let mods = {}
			for(const mod in getters.drone.AbilityScores){
				mods[mod] = Math.floor((getters.drone.AbilityScores[mod] - 10) / 2)
			}
			return mods
		} else {
			return null
		}

	},
	currentHP: (state, getters, rootState) => {
		if( getters.drone )
			return rootState.Character.Current.Drone.Points.Hit
		else
			return null
	},
	currentRP: (state, getters, rootState) => {
		if( getters.drone )
			return rootState.Character.Current.Drone.Points.Resolve
		else
			return null
	},
}

const actions = {
	setHP: ({ commit }, n) => {
		commit('setCharacterProp',[
			{
				key: `Current.Drone.Points.Hit`,
				val: n
			}
		],{
			root: true,
		})
	},
	setRP: ({ commit }, n) => {
		commit('setCharacterProp',[
			{
				key: `Current.Drone.Points.Resolve`,
				val: n
			}
		],{
			root: true,
		})
	},
	setDroneProp: ( {commit}, payload ) => {
		commit('setCharacterProp',[
			{
				key: `Levels[${payload.level}].Drone.${payload.property}`,
				val: payload.value
			}
		],{
			root: true,
		})
	},
	updateName: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Name',
		}))
	},
	updateDlevel: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Level',
		}))
	},
	updateType: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Type',
		}))
	},
	updateSize: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Size',
		}))
	},
	updateSpeed: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Speed',
		}))
	},
	updateEac: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'EAC',
		}))
	},
	updateKac: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'KAC',
		}))
	},
	updateSave: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'GoodSave',
		}))
	},
	updateSkills: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Skills',
		}))
	},
	updateInitial: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'InitialMods',
		}))
	},
	updateScores: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'AbilityScores',
		}))
	},
	updateIncreases: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'AbilityIncreases',
		}))
	},
	updateMods: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Mods',
		}))
	},
	updateFeats: ({ dispatch }, payload) => {
		dispatch('setDroneProp', _merge( payload, { 
			property:'Feats',
		}))
	},
}

const mutations = {
	
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}